import styled from "styled-components";
import { colors, spacingExtender } from "ui-components";

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 40px;
  color: ${colors.whiteGrey};
  background-color: ${colors.darkBlue};
  box-shadow: ${({ theme }) => theme.shadow};
  border-radius: 5px;
  overflow: hidden;
  ${() => spacingExtender({ paddingH: "3" })};
`;

export { HeaderWrapper };



// WEBPACK FOOTER //
// ./src/common/components/ContentHeader/styled.js